import api from "../Service/Api";
import { toastr } from "react-redux-toastr";
import generalFunc from "../Utils/generalFunc";

const pcaBaseController = "api/post-camp"
const usersBaseController = "api/users"
const skillsBaseController = "api/skills"

export const exportPcaReport = async () => {
  try {
    if (navigator.onLine) {
      const response = await api.get(`${pcaBaseController}/export-PostCampMgmts`, {
        headers: { 'Content-Type': 'blob', },
        responseType: 'arraybuffer',
      })
      if (response.status === 200) {
        toastr.success('Downloading Report', 'Please check your downloads folder for the Report')

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a")
        link.href = url

        link.setAttribute("download", `SAED Post Camp Activities Report ${generalFunc.getCurrentYear()}.xlsx`)
        document.body.appendChild(link)

        link.click()
      }
      return null;
    }
  } catch (error) {
    toastr.error('Oops', 'We encountered an error downloading the report. Please try again')
    throw error;
  }
}

export const pcaFindCm = async (body) => {
  try {
    if (navigator.onLine) {
      const response = await api.post(`${usersBaseController}/get-corp-member`, body)
      return response.data.data.data;
    }
  } catch (error) {
    if (error.code === 'ERR_BAD_REQUEST') { 
      toastr.error("An error occurred", error.response.data.message)
    } else if (error.code === 'ERR_BAD_RESPONSE') { // error from server
      toastr.error("We encountered an error processing that request", "Please try again shortly")
    }
    throw error;
  }
}

  ;
export const pcaGetAllActiveSkills = async () => {
  try {
    if (navigator.onLine) {
      const response = await api.get(`${skillsBaseController}/get-all-active-skills`);
      return response.data.data;
    }
  } catch (error) {
    throw error;
  }
}

export const createPCARecord = async body => {
  try {
    if (navigator.onLine) {
      const response = await api.post(`${pcaBaseController}/create-PostCampMgmt`, body)
      toastr.success(`Post Camp Activity Captured Successfully!`)
      return response.data.data;
    }
  } catch (error) {
    toastr.error(error.response.data.title, error.response.data.message)
    throw error;
  }
}

export const getAllRegisteredCmPca = async (body = {}) => {
  const urlParams = generalFunc.generateUrlParams(body)
  try {
    if (navigator.onLine) {
      const response = await api.get(`${pcaBaseController}/get-all-PostCampMgmts${urlParams}`)
      return response.data;
    }
  } catch (error) {
    toastr.error(error.response.data.errors, error.response.data.message)
    throw error;
  }
}

export const getCmPcaByIdApi = async id => {
  try {
    if (navigator.onLine) {
      const response = await api.get(`${pcaBaseController}/get-PostCampMgmt-by-id/${id}`)
      return response.data.data;
    }
  } catch (error) {
    throw error;
  }
}

export const editPcaDataApi = async payload => {
  try {
    if (navigator.onLine) {
      const response = await api.put(`${pcaBaseController}/edit-PostCampMgmt/${payload.id}`, payload.body);
      toastr.success(`Edits successfully saved`)
      return response.data.data;
    }
  } catch (error) {
    toastr.error(`We encountered an error saving your details`, `Please try again shortly`)
    throw error;
  }
}